(() => {
  const init = () => {
    const section = document.querySelector('[data-founder-parallax-section]');
    const media = section?.querySelector('[data-founder-parallax-media]');

    if (!section || !media) return;

    if (!window.gsap) {
      setTimeout(init, 100);
      return;
    }

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    const updateAnimation = () => {
      const rect = section.getBoundingClientRect();
      const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
      const startVisible = viewportHeight;
      const endVisible = 0;
      const progress = (startVisible - rect.top) / (startVisible - endVisible);
      const clampedProgress = Math.min(Math.max(progress, 0), 1);
      const translateY = -160 + (160 * clampedProgress);

      window.gsap.to(media, {
        y: translateY,
        duration: 0.1,
        ease: 'none',
        overwrite: 'auto'
      });
    };

    window.addEventListener('scroll', updateAnimation, { passive: true });
    window.addEventListener('resize', updateAnimation, { passive: true });
    updateAnimation();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
